<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import EventBasicData from './form/BasicData.vue'
  import EventModalities from './form/Modalities.vue'
  import EventPaperTypes from './form/PaperTypes.vue'

  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'

  import helpers from '@mixins/helper'
  import bus from '@utils/bus'

  import {clone} from 'lodash'
  import swal from 'sweetalert2'

  const defaultState = {
    event_id: '',
    place_id: '',
    title: '',
    start_datetime: '',
    end_datetime: '',
    start_registration_datetime: '',
    end_registration_datetime: '',
    contact_email: '',
    website: '',
    description: '',
    has_material: false,
    events: []
  }

  export default {
    components: {ListHeader, EventBasicData, EventModalities, EventPaperTypes},
    mixins: [helpers],
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        event: {
          id: '',
          event_id: '',
          events: []
        },
        tabs: {
          activeName: 'event.update.basic-data',
          tabBasicDataDisabled: false,
          tabModalitiesDisabled: true,
          tabPaperTypesDisabled: true
        }
      }
    },
    created: function () {
      const id = this.$route.params.id || null
      this.loadData(id)
    },
    watch: {
      '$route.params.id': function (id) {
        this.loadData(id)
      }
    },
    methods: {
      loadData (id) {
        bus.$emit('show-loader')
        if (id) {
          this.isEdit = true
          restfulService.get('event', null, id, null, ['events'])
            .then(response => {
              this.event = response
              this.tabs.tabModalitiesDisabled = false
              this.tabs.tabPaperTypesDisabled = false
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
            .catch(e => {
              console.log(e)
              bus.$emit('hide-loader')
              this.isLoadingData = false
            })
        } else {
          bus.$emit('hide-loader')
          this.isLoadingData = false
        }
      },
      createSubevent () {
        const event = clone(defaultState)
        event.event_id = this.event.id
        this.$router.push({name: 'event.store', params: {eventId: this.event.id}})
      },
      cloneEvent (item) {
        swal({
          title: 'Deseja realmente clonar esse Evento?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            this.isSubmitted = true
            const data = {}
            restfulService.post('event', 'clone', item.id, data)
              .then(response => {
                notifyService.success({hideLoader: true})
                this.isSubmitted = false
                this.$router.push({name: 'event.update.basic-data', params: {id: response.id}})
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
          })
      },
      deleteEvent (item) {
        swal({
          title: 'Deseja realmente remover esse Evento?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            this.isSubmitted = true
            restfulService.destroy('event', null, item.id)
              .then(response => {
                notifyService.success({hideLoader: true})
                this.isSubmitted = false
                this.event.events = this.event.events.filter(event => event.id !== item.id)
                bus.$emit('hide-loader')
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <ListHeader :title="'Evento: '+event.title"/>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card class="el-card__save_form box-card">
                    <div slot="header">
                        <span>Dados do Evento</span>
                        <router-link :to="{name: 'event.update.basic-data', params: { id: event.event_id}}"
                                     v-if="event.event_id"
                                     class="el-button back-button">
                            Voltar para o evento pai
                        </router-link>
                    </div>
                    <div>
                        <div class="event-tabs">
                            <div class="event-tabs-links">
                                <router-link :to="{name: 'event.update.basic-data', params: {id: event.id}}"
                                             class="el-tabs__item is-top">
                                    <i class="fa fa-file"></i>
                                    <span>Dados Gerais</span>
                                </router-link>
                                <router-link :to="{name: 'event.update.modalities', params: {id: event.id}}"
                                             :disabled="!event.id"
                                             class="el-tabs__item is-top">
                                    <i class="fa fa-users"></i>
                                    <span>Modalidades</span>
                                </router-link>
                                <router-link
                                        :to="{name: 'event.update.paper-types', params: {id: event.id}}"
                                        :disabled="!event.id"
                                        v-if="event.event_id"
                                        class="el-tabs__item is-top">
                                    <i class="fa fa-address-card-o"></i>
                                    <span>Trabalhos</span>
                                </router-link>
                                <router-link
                                        :to="{name: 'event.update.evaluations', params: {id: event.id}}"
                                        :disabled="!event.id"
                                        v-if="event.event_id"
                                        class="el-tabs__item is-top">
                                    <i class="fa fa-calculator"></i>
                                    <span>Avaliações</span>
                                </router-link>
                            </div>
                            <router-view></router-view>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="el-card__save_form box-card">
                    <div slot="header">
                        <span>Subeventos</span>
                        <el-button type="default"
                                   v-if="event.id"
                                   @click="createSubevent"
                                   class="back-button">
                            Criar novo Subevento
                        </el-button>
                    </div>
                    <div v-if="event.events.length > 0">
                        <table class="custom-table-list">
                            <thead>
                            <tr>
                                <th>Título</th>
                                <th>Data de Início</th>
                                <th>Data de Término</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in event.events">
                                <td>{{item.title}}</td>
                                <td>{{item.start_datetime | dateTimeEnToBr}}</td>
                                <td>{{item.end_datetime | dateTimeEnToBr}}</td>
                                <td width="160">
                                    <el-button type="warning"
                                               size="small"
                                               @click="cloneEvent(item)"
                                               title="Duplicar Evento">
                                        <i class="fa fa-clone"></i>
                                    </el-button>
                                    <router-link :to="{name: 'event.show.home', params: { id: item.id}}"
                                                 v-if="false"
                                                 class="el-button el-button--primary el-button--small"
                                                 title="Gerenciar Evento">
                                        <i class="fa fa-cog"></i>
                                    </router-link>
                                    <router-link :to="{name: 'event.update.basic-data', params: { id: item.id}}"
                                                 class="el-button el-button--info el-button--small"
                                                 title="Editar Evento">
                                        <i class="fa fa-edit"></i>
                                    </router-link>
                                    <el-button type="danger"
                                               size="small"
                                               @click="deleteEvent(item)"
                                               title="Remover Evento">
                                        <i class="fa fa-trash"></i>
                                    </el-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <p v-else="">Nenhum sub-evento encontrado</p>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<style lang="scss">
    .back-button {
        float: right;
        margin: 0;
        position: relative;
        top: -8px;
    }

    .event-tabs {
        .event-tabs-links {
            display: flex;
            margin-bottom: 20px;
            border-bottom: 2px solid #00a65a;
            .el-tabs__item {
                text-decoration: none;
                padding: 0 10px;
                font-size: 12px;
                &.router-link-exact-active {
                    background-color: #00a65a !important;
                    color: #FFF !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Form.vue?eb9b5e26